import { render, staticRenderFns } from "./Submeter.vue?vue&type=template&id=bf3650fa"
import script from "./Submeter.vue?vue&type=script&lang=js"
export * from "./Submeter.vue?vue&type=script&lang=js"
import style0 from "./Submeter.vue?vue&type=style&index=0&id=bf3650fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports